import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import ArrowrightIcon from 'icons/Arrowright.icon';
import ClipboardcopyIcon from 'icons/Clipboardcopy.icon';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import useCopyToClipboard from 'hooks/useCopyToClipboard';

import './ShareableLinkCreated.styles.scss';
import './ShareableLinkCreated.styles.responsive.scss';

type ShareableLinkCreatedProps = {
  className?: string;
  url: string;
  onViewAll: () => void;
};

const ShareableLinkCreated: React.FC<ShareableLinkCreatedProps> = (props) => {
  const { className, url, onViewAll } = props;

  const classes = classNames('shareable-link-created', className);

  const { t } = useTranslation();

  const copyToClipboard = useCopyToClipboard();

  return (
    <div className={classes}>
      <CheckcircleIcon />

      <p>{t('linkCreated')}</p>

      <div className="shareable-link-created__actions">
        <Button
          iconPosition="right"
          icon={ClipboardcopyIcon}
          onClick={(e) => {
            copyToClipboard(e, url);
          }}
        >
          {t('copyLink')}
        </Button>
        <Button
          variant="link"
          iconPosition="right"
          icon={ArrowrightIcon}
          onClick={onViewAll}
        >
          {t('viewAllLinks')}
        </Button>
      </div>
    </div>
  );
};

export default ShareableLinkCreated;
